import { render, staticRenderFns } from "./PaymentLogin.vue?vue&type=template&id=570bf879&scoped=true"
import script from "./PaymentLogin.vue?vue&type=script&lang=js"
export * from "./PaymentLogin.vue?vue&type=script&lang=js"
import style0 from "./PaymentLogin.vue?vue&type=style&index=0&id=570bf879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570bf879",
  null
  
)

export default component.exports